var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z",
    stroke: "url(#paint0_linear_6859_11450)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11V16",
    stroke: "url(#paint1_linear_6859_11450)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9941 8H12.0031",
    stroke: "url(#paint2_linear_6859_11450)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6859_11450",
    x1: 4.47619,
    y1: 8.21359,
    x2: 20.2857,
    y2: 8.21359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498678,
    stopColor: "#F64562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C22DE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6859_11450",
    x1: 12.1238,
    y1: 12.5534,
    x2: 12.9143,
    y2: 12.5534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498678,
    stopColor: "#F64562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C22DE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6859_11450",
    x1: 11.9953,
    y1: 8.31068,
    x2: 12.0024,
    y2: 8.31068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498678,
    stopColor: "#F64562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C22DE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.31c91d20e56d3649e7babb1b35509698.svg";
export { ForwardRef as ReactComponent };